import React, { useState } from 'react';
import ChartWithStats from '../components/ChartWithStats';
import { FWurfData } from '../data/FWurfData';
import { CWurfData } from '../data/CWurfData';
import { GWurfData } from '../data/GWurfData';
import { SollData } from '../data/SollData';
import { RidgebackWurfData } from "../data/RidgebackWurfData";

const KombinierteAnsicht = () => {
    const [useGruppierteLegende, setUseGruppierteLegende] = useState(true);

    const combinedDataSources = [
        FWurfData.Feamara,
        FWurfData.Feanor,
        FWurfData.FrodoFili,
        FWurfData.Faramir,
        GWurfData.Dunkel,
        GWurfData.Rüde,
        GWurfData.Braun,
        GWurfData.Silber,
        RidgebackWurfData.Fille1,
        RidgebackWurfData.Fils2,
        RidgebackWurfData.Fils3,
        RidgebackWurfData.Fils4,
        RidgebackWurfData.Fils5,
        RidgebackWurfData.Fils6,
        RidgebackWurfData.Fils7,
        RidgebackWurfData.Fils8,
        RidgebackWurfData.Fille9,
        RidgebackWurfData.Fille10,
        RidgebackWurfData.Fille11,
        RidgebackWurfData.Fille12,
        CWurfData.rot,
        CWurfData.pink,
        CWurfData.blau,
        CWurfData.gelb,
        CWurfData.orange,
        CWurfData.lila,
        CWurfData.gruen
    ];

    const allLengths = combinedDataSources.map(p => p.data.length);
    const arrayLength = 64;
    const startDate = new Date(2024, 11, 28);
    const labels = Array.from({ length: arrayLength }, (_, i) => {
        const currentDate = new Date(startDate);
        currentDate.setDate(startDate.getDate() + i);
        return currentDate.toLocaleDateString('de-DE', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
        });
    });

    const fwurfLabels = ['Feamára', 'Fëanor', 'Frodo Fíli', 'Faramir'];
    const cwurfLabels = ['Rot', 'Pink', 'Blau', 'Grün',  'Gelb', 'Lila', 'Orange'];
    const gwurfLabels = ['Dunkel', 'Rüde', 'Braun', 'Silber'];

    const chartDatasets = combinedDataSources.map(puppy => ({
        label: puppy.label,
        data: puppy.data.slice(0, arrayLength),
        borderColor: puppy.borderColor,
        backgroundColor: puppy.backgroundColor,
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 5,
        sex: puppy.sex,
        borderWidth: 3,
        dataType: fwurfLabels.includes(puppy.label)
            ? 'F'
            : gwurfLabels.includes(puppy.label)
                ? 'G'
                : cwurfLabels.includes(puppy.label)
                    ? 'C'
                    : (puppy.label.includes('Fils') || puppy.label.includes('Fille') ? 'Ridgeback' : undefined),
    }));

    chartDatasets.push(
        {
            label: 'Soll (+)',
            data: SollData.sollHoch.slice(0, arrayLength),
            borderColor: 'rgba(169, 169, 169, 1)',
            borderDash: [5, 5],
            fill: false,
            tension: 0.4,
            pointRadius: 4,
            pointHoverRadius: 5,
            borderWidth: 1,
        },
        {
            label: 'Soll (-)',
            data: SollData.sollNiedrig.slice(0, arrayLength),
            borderColor: 'rgba(0, 0, 0, 1)',
            borderDash: [5, 5],
            fill: false,
            tension: 0.4,
            pointRadius: 4,
            pointHoverRadius: 5,
            borderWidth: 1,
        }
    );

    const allChartValues = chartDatasets.flatMap(dataset => dataset.data);
    const numericValues = allChartValues.filter(value => typeof value === 'number');
    const maxValue = Math.ceil(Math.max(...numericValues));

    return (
        <div style={{overflowX: 'unset'}}>
            <ChartWithStats
                chartTitle="Kombi"
                chartDatasets={chartDatasets}
                chartLabels={labels}
                milestones={[]}
                startDate={[2024, 11, 28]}
                duration={1}
                maxValue={maxValue}
                xxx={useGruppierteLegende}
                kombiniert={true}
            />
        </div>
    );
};

export default KombinierteAnsicht;
